module.exports = __webpack_public_path__ + "img/reply-2.3dbee452.jpg";